import { render, staticRenderFns } from "./LoyaltyCard.vue?vue&type=template&id=1f862419&scoped=true"
import script from "./LoyaltyCard.vue?vue&type=script&lang=js"
export * from "./LoyaltyCard.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyCard.vue?vue&type=style&index=0&id=1f862419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f862419",
  null
  
)

export default component.exports